import { render, staticRenderFns } from "./ProgressDetailDialog.vue?vue&type=template&id=6224e434"
import script from "./ProgressDetailDialog.vue?vue&type=script&lang=js"
export * from "./ProgressDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports